'use strict';

module.exports = typeof window !== 'undefined' && window;
//# sourceMappingURL=windowGlobal.js.map